module.exports = __webpack_public_path__ + "assets/img/Type BS (12).2df9d86e.jpg";